import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Carrier catalog UI has been retired from the operator surface.
 * Carrier reference data (service codes, mappings, certification metadata)
 * is infrastructure — operators only manage shipping via Connections.
 * Deep links land on the Connections workspace, filtered to shipping.
 */
export const Route = createFileRoute("/_authenticated/app/admin/carriers")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/admin/connections",
      search: { category: "shipping" } as never,
    });
  },
});